import type { JSX } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { AvatarColor } from "../../modules/shared/types";

// eslint-disable-next-line react-refresh/only-export-components
export function sourceBg(color: AvatarColor | undefined): string {
  switch (color) {
    case "blue":
      return "bg-blue";
    case "green":
      return "bg-green";
    case "red":
      return "bg-red";
    case "purple":
      return "bg-purple";
    case "pink":
      return "bg-pink";
    case "gray":
      return "bg-content-tertiary";
    default:
      return "bg-accent";
  }
}

export interface MarkdownTextProps {
  readonly text: string;
  readonly className?: string;
}

export function MarkdownText({ text, className }: MarkdownTextProps): JSX.Element {
  return (
    <div className={`agent-markdown ${className ?? ""}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node: _node, ...props }) => (
            <a {...props} target="_blank" rel="noreferrer noopener" />
          ),
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
